/**
 * Swaps the controller and the template of the md-chips directive from Angular Material
 *
 * @type {ngDecorator}
 * @see tmrMdChipsController
 */
function mdChipsDirectiveDecorator($delegate, $mdUtil) {
  'ngInject'
  $delegate[0].controller = 'tmrMdChipsController'

  // Override template to put the text input field before the list of chips.
  let MD_CHIPS_TEMPLATE = `
  <md-chips-wrap
      id="{{$mdChipsCtrl.wrapperId}}"
      tabindex="{{$mdChipsCtrl.readonly ? 0 : -1}}"
      ng-keydown="$mdChipsCtrl.chipKeydown($event)"
      ng-class="{ 'md-focused': $mdChipsCtrl.hasFocus(),
                  'md-readonly': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,
                  'md-removable': $mdChipsCtrl.isRemovable() }"
      class="md-chips">
    <div class="md-chip-input-container" ng-if="!$mdChipsCtrl.readonly && $mdChipsCtrl.ngModelCtrl">
      <div md-chip-transclude="$mdChipsCtrl.chipInputTemplate"></div>
    </div>
    <md-chip ng-repeat="$chip in $mdChipsCtrl.items"
        index="{{$index}}"
        ng-class="{'md-focused': $mdChipsCtrl.selectedChip == $index, 'md-readonly': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}">
      <div class="md-chip-content"
          tabindex="{{$mdChipsCtrl.ariaTabIndex === $index ? 0 : -1}}"
          id="{{$mdChipsCtrl.contentIdFor($index)}}"
          role="option"
          aria-selected="{{$mdChipsCtrl.selectedChip === $index}}"
          aria-setsize="{{$mdChipsCtrl.items.length}}"
          aria-posinset="{{$index+1}}"
          ng-click="!$mdChipsCtrl.readonly && $mdChipsCtrl.focusChip($index)"
          aria-label="{{$mdChipsCtrl._isChipObject($chip) ? '' : $chip + '. '}}{{$mdChipsCtrl.isRemovable() ? '' + $mdChipsCtrl.deleteHint : ''}}"
          ng-focus="!$mdChipsCtrl.readonly && $mdChipsCtrl.selectChip($index)"
          md-chip-transclude="$mdChipsCtrl.chipContentsTemplate"></div>
      <div ng-if="$mdChipsCtrl.isRemovable()"
            class="md-chip-remove-container"
            tabindex="-1"
            md-chip-transclude="$mdChipsCtrl.chipRemoveTemplate"></div>
    </md-chip>
  </md-chips-wrap>`
  // Do the same complex stuff that Angular Material does.
  let template = $mdUtil.processTemplate(MD_CHIPS_TEMPLATE)
  $delegate[0].template = (element, attrs) => {
    attrs['$mdUserTemplate'] = element.clone()
    return template
  }

  return $delegate
}

export let decorator = ['mdChipsDirective', mdChipsDirectiveDecorator]
